import { defineStore } from 'pinia';

export const useRedirectStore = defineStore('redirect', {
  state: () => ({
    redirectUrl: localStorage.getItem('redirectUrl') || null,
  }),
  getters: {
    hasRedirect: (state) => {
      return !!state.redirectUrl;
    },
  },
  actions: {
    set(url: string | null) {
      if (!url) {
        this.clear();
        return;
      } else if (url?.includes('entra')) return; // prevent redirect  loop to entra

      this.redirectUrl = url;
      localStorage.setItem('redirectUrl', url);
    },
    clear() {
      this.redirectUrl = null;
      localStorage.removeItem('redirectUrl');
    },
  },
});
